import { Label } from '@atoms/index';
import { NavigationButtons } from '@molecules/index';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../routes/Routes';
import phone_black from '@highways/assets/phone_black.svg';
import phone_white from '@highways/assets/phone_white.svg';
import { useState } from 'react';
import { scrollTop } from '@utils';

interface CallUsLabelProps {
  isFocus: boolean;
}

const CallUsLabel = ({ isFocus }: CallUsLabelProps) => {
  return (
    <div className="mx-[0.5rem] flex items-center justify-center gap-2 font-semibold">
      Call us
      <img src={isFocus ? phone_black : phone_white} alt="phone-icon" />
    </div>
  );
};

export const CallUsPage = () => {
  const navigate = useNavigate();
  const [isFocus, setIsFocus] = useState(false);
  const buttonPrevious = {
    label: 'Previous',
    onClick: () => {
      navigate(RoutesList.HIGHWAYS_DAMAGE);
      scrollTop();
    },
  };
  const buttonNext = {
    label: <CallUsLabel isFocus={isFocus} />,
    isExternalLink: true,
    href: 'tel:+441135182215',
    icon: null,
    onFocus: () => {
      setIsFocus(true);
    },
    onBlur: () => {
      setIsFocus(false);
    },
    onMouseDown: () => {
      setIsFocus(false);
    },
  };

  return (
    <div>
      <div className="ml-2 mt-[25px]">
        <Label text="Call us" className="text-brand-primary" isTitle={true} />
      </div>
      <div className="text-h4 my-6 ml-2 flex flex-col gap-5">
        <p>We think this could be a priority issue.</p>
        <p>Get in touch so your report can be assessed and submitted.</p>
        <div className="p-0 font-semibold">
          <p>Contact us now:</p>
          <p>020 7641 2000</p>
        </div>
      </div>

      <NavigationButtons
        buttonPrevious={buttonPrevious}
        buttonNext={buttonNext}
      />
    </div>
  );
};
